var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import React from "react";
const ErrorIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "28", height: "28", viewBox: "0 0 28 28" }, props), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "#F64D43" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M9.333 18.148C4.46 18.148.52 14.208.52 9.333.519 4.46 4.459.52 9.333.52c4.874 0 8.815 3.94 8.815 8.814 0 4.874-3.94 8.815-8.815 8.815zm0 0c4.874 0 8.815-3.94 8.815-8.815 0-4.874-3.94-8.814-8.815-8.814C4.46.519.52 4.459.52 9.333c0 4.874 3.94 8.815 8.814 8.815zM9.333 4.148L9.333 11.407M9.333 13.481L9.333 14.519",
    transform: "translate(4.667 4.667)"
  }
)));
var errorIcon_default = ErrorIcon;
export {
  errorIcon_default as default
};
//# sourceMappingURL=errorIcon.js.map
